import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CloudNameStorageService {

  storageKey = "cloud_name";

  constructor() { }

  loadCloudName() {
    return localStorage.getItem(this.storageKey);
  }

  storeCloudName(v) {
    localStorage.setItem(this.storageKey, v);
  }

  clearCloudName() {
    localStorage.removeItem(this.storageKey);
  }
}
